import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { DialogContent, DialogTitle, DialogActions, useMediaQuery, useTheme } from "@material-ui/core";

import FormWrapper from "components/FormWrapper";
import ModalWithOpener from "components/ModalWithOpener";
import ModalFormActions from "components/FormInDialog/components/ModalFormActions";

import { SUCCESS_STATUS } from "components/MessageService/constants";
import "./FormInDialog.css";

// Component to provide Formik context to ModalFormActions
const FormikModalActions = ({ formProps, ...props }) => {
  return (
    <FormWrapper
      {...formProps}
      fields={[]}
      OnSubmitActionComponent={() => (
        <ModalFormActions {...props} />
      )}
    />
  );
};

const FormInDialog = ({
  OpenerComponent,
  title,
  submitActionText,
  cancelActionText,
  formFields,
  actionOnOpen,
  actionOnClose,
  ...formProps
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { messagePayload } = useSelector(({ helperReducer }) => helperReducer);

  const openModal = () => {
    setIsOpen(true);

    if (actionOnOpen) actionOnOpen();
  };

  const closeModal = () => {
    setIsOpen(false);

    if (actionOnClose) actionOnClose();
  };

  useEffect(() => {
    if (messagePayload && messagePayload.type === SUCCESS_STATUS) {
      closeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagePayload]);

  return (
    <ModalWithOpener
      open={isOpen}
      OpenerComponent={<OpenerComponent onClick={openModal} />}
      onClose={closeModal}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent
          className="custom-scrollable-content"
          style={{
            padding: '24px',
          }}
        >
          <FormWrapper
            {...formProps}
            fields={formFields}
            OnSubmitActionComponent={(props) => (
              <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                <FormikModalActions
                  formProps={formProps}
                  onSubmitActionText={submitActionText}
                  closeModalText={cancelActionText}
                  closeModal={closeModal}
                  isMobile={isMobile}
                  {...props}
                />
              </div>
            )}
          />
        </DialogContent>
      </>
    </ModalWithOpener>
  );
};

FormInDialog.propTypes = {
  OpenerComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  title: PropTypes.string.isRequired,
  submitActionText: PropTypes.string.isRequired,
  cancelActionText: PropTypes.string.isRequired,
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formFields: PropTypes.array.isRequired,
};

export default FormInDialog;
